const TemplateEnum = {
    order: 1,
    letter: 2,
    insideLetter: 3
}

export default TemplateEnum